import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Input,
  ListGroup,
  ListGroupItem,
  Container,
  Row,
  Col,
  Button,
  Pagination,
  PaginationItem,
  Table,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
  Label,
  FormGroup,
  Badge,
  Toast,
  CardHeader
} from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaArrowDown, FaArrowUp, FaBalanceScale, FaBarcode, FaBuilding, FaCalendarAlt, FaCartPlus, FaCreditCard, FaEnvelope, FaHistory, FaIdCard, FaImage, FaList, FaMapMarkerAlt, FaMinus, FaMoneyBillWave, FaPhone, FaPlus, FaPrint, FaReceipt, FaSearch, FaShieldAlt, FaShoppingCart, FaStore, FaTh, FaTrash, FaUser, FaWhatsapp } from 'react-icons/fa'; // Import trash icon
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useTranslation } from "react-i18next";
import { FaSave, FaTrashAlt } from 'react-icons/fa';
import emptyCart from "../../assets/images/empty-cart.png";
import { productActions } from "../../sagas/productSlice";
import { useDispatch, useSelector } from "react-redux";
import { debounce, set } from "lodash";
import { saleActions } from "../../sagas/saleSlice";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import config from "../../helpers/config";
import amiriNormal from '../../assets/fonts/Amiri-Regular.ttf';
import { clientActions } from "../../sagas/clientSlice";
import ClientForm from "../Client/ClientForm";
import Select from "react-select";
import { components } from 'react-select';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { deliveryActions } from "../../sagas/deliveryNoteSlice";
import { transporteurActions } from "../../sagas/transporteurSlice";
import { entrepotActions } from "../../sagas/entrepotSlice";
import { da } from "date-fns/locale";
import { reglementActions } from "../../sagas/reglementSlice";
import { commercialActions } from "../../sagas/commercialSlice";
import { formatSigned, preventScroll } from "../../helpers/utility";
import './SalesForm.css';


const initialValues = {
  numero: '',
  commandeId: null,
  commercialId: null,
  commandeNumero: '',
  commandeDateCreation: new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().split('T')[0],
  clientId: null,
  chantierId: null,
  clientNom: '',
  clientAdresse: '',
  clientIce: '',
  clientTelephone1: '',
  clientTelephone2: '',
  clientEmail: '',
  deliveryNoteNb: '',
  estLivraisonDirecte: false,
  dateLivraison: new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().split('T')[0],
  lignes: [],
  montantCheque: 0,
  montantTotalHT: 0,
  montantTotalTTC: 0,
  montantTotalTaxe: 0,
  montantPaye: 0,
  addresseLivraison: '',
  modeReglement: 'ESPECES',
  dateOperation: new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().split('T')[0],
  entrepotId: null,
  transporteurId: null,
  transporteurNom: '',
  transporteurTelephone: '',
  status: 'EN_ATTENTE',
  accuse: false,
  estFacture: false,
  numeroFacture: '',
  isClientParticulier: false,
  numeroCheque: '',
  banque: '',
  dateEcheanceCheque: null
};

const validationSchema = Yup.object({
  clientId: Yup.number().nullable(),
  dateLivraison: Yup.date().required('Date de livraison requise'),
  addresseLivraison: Yup.string().required('Adresse de livraison requise'),
  modeReglement: Yup.string()
    .required('Mode de règlement requis')
    .oneOf(['ESPECES', 'CHEQUE', 'VIREMENT', 'TRAITE', 'CARTE_BANCAIRE'], 'Mode de règlement invalide')
});

const SaleForm = () => {
  const montantTotalTTC = useSelector(state => state.sales?.montantTotalTTC || 0);
  const montantTotalHT = useSelector(state => state.sales?.montantTotalHT || 0);
  const montantTotalTaxe = useSelector(state => state.sales?.montantTotalTaxe || 0);

  const [searchTerm, setSearchTerm] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const cart = useSelector(state => state.sales?.cart || []);
  const [cartPage, setCartPage] = useState(1);

  const [clearCartModal, setClearCartModal] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  const fullName = useSelector(state => state.auth.fullName);
  const { businessName, email, address, telephone } = useSelector(state => state.auth);
  const [displayMode, setDisplayMode] = useState('table'); // or 'card'
  const [showClientModal, setShowClientModal] = useState(false);
  const { transporteurs } = useSelector(state => state.transporteurs);
  const { entrepots } = useSelector(state => state.entrepots);

  const [filters, setFilters] = useState({
    clientId: null,
    dateFrom: null,
    dateTo: null,
    statut: "EN_ATTENTE"
  });

  const villesMaroc = [
    'Casablanca', 'Rabat', 'Marrakech', 'Fès', 'Tanger',
    'Agadir', 'Meknès', 'Oujda', 'Kénitra', 'Tétouan',
    'Safi', 'Mohammedia', 'El Jadida', 'Nador', 'Beni Mellal'
  ];

  const [client, setClient] = useState({
    nom: '',
    prenom: '',
    cin: '',
    telephone1: '',
    telephone2: '',
    email: '',
    adresse: '',
    ville: 'Casablanca',
    typeClient: 'PARTICULIER',
    codePostal: '',
    plafond: 0,
    entreprise: '', // New field for "Entreprise"
    ice: '',// New field for "ICE",
    active: true,
    solde: 0 // Ce champ sera en lecture seule
  });
  // Add inside component
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    products,
    loading,
    totalPages,
    totalElements,
    pageNumber,
    pageSize,
    error,
  } = useSelector((state) => state.products);
  const unites = useSelector(status => status.products.unites); // Assuming you have a Redux store with unites

  const { loading: loadingReglements, error: errorReglements, echeances, cautions } = useSelector((state) => state.reglements);
  const clients = useSelector(state => state.clients.clients);
  const [criteria, setSearchCriteria] = useState({ query: '' });
  const searchInputRef = useRef(null);
  const [clientModal, setClientModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedChantier, setSelectedChantier] = useState(null);
  const [selectedCommercial, setSelectedCommercial] = useState(null);
  const [selectedEntrepot, setSelectedEntrepot] = useState(null);
  const [selectedTransporteur, setSelectedTransporteur] = useState(null);
  const [showClientForm, setShowClientForm] = useState(false);
  const [showCheckoutModal, setShowCheckoutModal] = useState(false);
  const toggleClearCartModal = () => setClearCartModal(!clearCartModal);
  const [clientErrors, setClientErrors] = useState({});
  const { list: commercialList, loading: commercialLoading } = useSelector((state) => state.commercials); // Adjust state path as needed

  const toggleClientModal = () => {
    setClientModal(!clientModal);
    setShowClientForm(false); // Reset form visibility when modal is toggled
  }
  // Add new state
  const cartItemsPerPage = 20;
  // Calculate cart pagination
  const cartTotalPages = Math.ceil(cart.length / cartItemsPerPage);
  const cartStartIndex = (cartPage - 1) * cartItemsPerPage;
  const cartEndIndex = cartStartIndex + cartItemsPerPage;
  const currentCartItems = cart.slice(cartStartIndex, cartEndIndex);
  const [showEcheanceModal, setShowEcheanceModal] = useState(false);
  const [showCautionModal, setShowCautionModal] = useState(false);
  const togglePaymentModal = () => setPaymentModal(!paymentModal);

  useEffect(() => {
    // Fetch supplier options when the component mounts
    dispatch(clientActions.search({
      query: ""
    }));
    dispatch(productActions.findAllUnites());
    dispatch(transporteurActions.list());
    dispatch(entrepotActions.list());

  }, [selectedClient]);


  const { t } = useTranslation();

  const formatPrice = (amount, currency = true) => {
    const formattedPrice = new Intl.NumberFormat('fr-MA', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
    return currency ? `${formattedPrice} DH` : formattedPrice;
  };


  useEffect(() => {
    dispatch(productActions.findAll({
      search: "",
      page: currentPage - 1,
      size: 10,
    }));
    dispatch(commercialActions.list({ query: '' })); // Fetch commercials on component mount

  }, []);


  const commercialOptions = commercialList?.map(com => ({
    value: com.id,
    label: com.fullName,
  })) ?? [];

  useEffect(() => {
    // Auto focus on mount
    searchInputRef.current?.focus();

    // Add keyboard shortcut
    const handleKeyDown = (e) => {
      if (e.key === 'F2') {
        e.preventDefault();
        searchInputRef.current?.focus();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [products]);


  const transporteurOptions = transporteurs?.map(transporteur => ({
    value: transporteur.id,
    label: transporteur.code + ' - ' + transporteur.libelle,
  })) ?? [];

  const handleClientAdded = (newClient) => {
    dispatch(clientActions.search({
      query: ""
    }));
    setSelectedClient(newClient);
    setShowClientForm(false);
    toggleClientModal();
  };

  const clientOptions = clients?.map(client => ({
    solde: client.solde,
    totalDebit: client.totalDebit,
    totalCredit: client.totalCredit,
    chantiers: client.chantiers,
    value: client.id,
    label: client.typeClient === 'PARTICULIER'
      ? `${client.prenom} ${client.nom}`
      : client.entreprise,
  })) ?? [];

  const handleAddToCart = (product) => {
    dispatch(saleActions.addToCart(product));
  };

  const handleSelectClient = (client) => {
    setSelectedClient(client);
    dispatch(reglementActions.echeanceClient({ ...filters, clientId: client.id }));
    dispatch(reglementActions.cautionClient({ ...filters, clientId: client.id }));
    setFilters(f => ({ ...f, clientId: client.id }));
    toggleClientModal();
  };


  const handleInputChange = useCallback((index, event) => {
    const { name, value } = event.target;
    dispatch(saleActions.handleInputChange({ index, name, value }));
  }, [dispatch]);


  const handleRemoveFromCart = useCallback((productId) => {
    console.log(productId)
    dispatch(saleActions.removeFromCart(productId));
    setCartPage((prevPage) => {
      // Calculate new cart length after removal
      const newCartLength = cart.length - 1;
      const newTotalPages = Math.ceil(newCartLength / cartItemsPerPage);

      // If previous page is out of range, move to last valid page (at least 1)
      return prevPage > newTotalPages ? Math.max(1, newTotalPages) : prevPage;
    });
  }, [cart, cartItemsPerPage, dispatch]);

  // Debounced search function
  const debouncedSearch = useCallback(
    debounce((query) => {
      setIsSearching(true);
      dispatch(productActions.findAll({
        search: query,
        page: currentPage - 1,
        size: 10,
      }));
    }, 1000), // Wait 500ms after last keystroke
    []
  );

  // Handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    debouncedSearch(value);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSubmitClient = (e) => {
    e.preventDefault();

    const newErrors = {};
    // Common validations
    if (!client.telephone1) newErrors.telephone1 = 'Téléphone obligatoire';
    if (!client.adresse) newErrors.adresse = 'Adresse obligatoire';

    // Validations for "PARTICULIER"
    if (client.typeClient === 'PARTICULIER') {
      if (!client.nom) newErrors.nom = 'Nom obligatoire';
      if (!client.prenom) newErrors.prenom = 'Prénom obligatoire';
    }

    // Validations for "ENTREPRISE"
    if (client.typeClient === 'ENTREPRISE') {
      if (!client.entreprise) newErrors.entreprise = 'Nom de l\'entreprise obligatoire';
      if (!client.ice) newErrors.ice = 'Numéro ICE obligatoire';
    }


    if (Object.keys(newErrors).length > 0) {
      setClientErrors(newErrors);
      return;
    }

    let payload = {
      data: {
        ...client,
        chantiers: [],
      },

      onSuccess: () => {
        Swal.fire({
          icon: 'success',
          title: 'Succès',
          text: 'Client enregistrés avec succès!',
          confirmButtonText: 'OK',
        });

        setTimeout(() => {
          // Réinitialisation du formulaire après succès
          setClient({
            nom: '',
            prenom: '',
            cin: '',
            telephone1: '',
            telephone2: '',
            typeClient: 'PARTICULIER',
            email: '',
            adresse: '',
            ville: 'Casablanca',
            codePostal: '',
            plafond: 0,
            entreprise: '',
            ice: '',
            solde: 0,
            active: true,
          });

          // Fermeture du modal
          setShowClientModal(false);
        }, 2000);
      },
    };

    dispatch(clientActions.addClient(payload));

  }


  const handleClearCart = () => {
    Swal.fire({
      title: t('cart.clearConfirmMessage'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(saleActions.clearCart());
        setCartPage(1); // Reset cart page

      }
    });
  };

  const generatePDF = async () => {
    handleDownloadTicket(receiptData)
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      dispatch(productActions.findAll({
        search: searchTerm,
        page: currentPage - 1,
        size: 10,
      }));
    }
  };

  const DisplayToggle = () => (
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div className="btn-group">
        <Button
          color={displayMode === 'table' ? 'primary' : 'light'}
          onClick={() => setDisplayMode('table')}
          size="sm"
        >
          <FaList className="me-1" /> {t('common.table')}
        </Button>
        <Button
          color={displayMode === 'card' ? 'primary' : 'light'}
          onClick={() => setDisplayMode('card')}
          size="sm"
        >
          <FaTh className="me-1" /> {t('common.cards')}
        </Button>
      </div>

      <div className="d-flex align-items-center gap-3">
        {/* <small className="text-muted">
          {t('product.showing', {
            start: (currentPage - 1) * pageSize + 1,
            end: Math.min(currentPage * pageSize, totalElements),
            total: totalElements,
            currentPage: currentPage,
            totalPages: totalPages
          })}
        </small> */}

        <div className="d-flex align-items-center gap-2">
          <Button color="light" size="sm" onClick={() => handlePageChange(1)} disabled={currentPage === 1}>
            <FaAngleDoubleLeft />
          </Button>
          <Button color="light" size="sm" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
            <FaAngleLeft />
          </Button>

          <span className="mx-2">
            {currentPage} / {totalPages}
          </span>

          <Button color="light" size="sm" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
            <FaAngleRight />
          </Button>
          <Button color="light" size="sm" onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>
            <FaAngleDoubleRight />
          </Button>
        </div>
      </div>
    </div>
  );

  const TableView = () => (
    <>
      <div className="cart-container" style={{
        height: '550px',
        overflowY: 'auto'
      }}>
        <Table bordered hover>
          <thead>
            <tr>
              <th style={{ width: 250 }}>{t('product.description')}</th>
              <th>{t('product.salePrice')}</th>
            </tr>
          </thead>
          <tbody>
            {!products || (products ?? []).length === 0 ? (
              <tr>
                <td colSpan="2" className="text-center py-4">
                  <div className="text-muted">
                    {t('product.noProducts')}
                  </div>
                </td>
              </tr>
            ) : ((products ?? []).map((product) => (
              <tr key={product.id} onClick={() => handleAddToCart(product)}>
                <td>
                  {product.libelle}
                </td>
                <td className="align-middle text-end">
                  {formatPrice(product.prixVenteTTC1, false)} / {unites.find(u => u.code === product.unite)?.libelle}
                </td>
              </tr>
            ))
            )}
          </tbody>
        </Table>
      </div>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <small className="text-muted">
          {t('product.showing', {
            start: (currentPage - 1) * pageSize + 1,
            end: Math.min(currentPage * pageSize, totalElements),
            total: totalElements,
            currentPage: currentPage,
            totalPages: totalPages
          })}
        </small>
      </div>
    </>
  );

  const CardView = () => (
    <div style={{ height: '600px', overflowY: 'auto' }}>
      <Row xs={2} md={4} lg={4} className="g-3">
        {(!products || products.length === 0) && (
          <Col xs={12} className="text-center py-4 ">
            {t('product.noProducts')}
          </Col>
        )}
        {products.map(product => (
          <Col key={product.id}>
            <Card className="product-card rounded border shadow-sm" onClick={() => handleAddToCart(product)}>
              <div className="card-image-container">
                {product.photo ? (
                  <img
                    src={`${config.baseURL}${product.photo}`}
                    alt={product.libelle}
                    className="card-img-top rounded-top"
                  />
                ) : (
                  <div className="bg-placeholder rounded-top d-flex align-items-center justify-content-center">
                    <FaImage size={32} className="text-muted" />
                  </div>
                )}
              </div>
              <CardBody className="d-flex flex-column">
                <div className="d-flex justify-content-between align-items-start">
                  <h6 className="product-title mb-2">
                    {product.libelle.length > 30 ? product.libelle.substring(0, 30) + '...' : product.libelle}
                  </h6>
                </div>
                <p className="product-price">{formatPrice(product.prixVenteTTC1)} / {unites.find(u => u.code === product.unite)?.libelle}</p>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );

  const handleCreateSale = (values) => {

    if (!selectedTransporteur) {
      Swal.fire({
        icon: 'warning',
        title: t('sale.errorTitle'),
        text: t('sale.transportRequired')
      });
      return;
    }
    
    if (!selectedClient) {
      if (!values.montantPaye) {
        Swal.fire({
          icon: 'warning',
          title: t('sale.error'),
          text: t('payment.amountRequiredForWalkIn')
        });
        return;
      }

      if (parseFloat(values.montantPaye) < parseFloat(montantTotalTTC)) {
        Swal.fire({
          icon: 'warning',
          title: t('sale.error'),
          text: t('payment.amountMustEqualTotal')
        });
        return;
      }
    }



    const saleData = {
      clientId: selectedClient ? selectedClient.value : null,
      chantierId: selectedChantier ? selectedChantier.value : null,
      entrepotId: selectedEntrepot ? selectedEntrepot.value : null,
      commercialId: selectedCommercial ? selectedCommercial.value : null,
      isComptoir: true,
      isPassager: selectedClient ? false : true,
      transporteurId: selectedTransporteur ? selectedTransporteur.value : null,
      modeReglement: values.modeReglement,
      dateOperation: values.dateOperation,
      montantTotalHT: montantTotalHT,
      montantTotalTTC: montantTotalTTC,
      montantTotalTaxe: montantTotalTaxe,
      montantPaye: values.montantPaye > montantTotalTTC ? montantTotalTTC : values.montantPaye,
      status: 'LIVRE',
      lignes: cart.map(item => ({
        articleId: item.articleId,
        articleCode: item.articleCode,
        articleNom: item.articleNom,
        quantiteLivree: item.quantite,
        unite: unites.find(u => u.code === item.unite).libelle,
        prixUnitaireTTC: item.prixUnitaireTTC,
        prixUnitaireHT: item.prixUnitaireHT,
        montantHT: item.montantHT,
        montantTTC: item.montantTTC,
        tauxTVA: item.tauxTVA
      }))
    };

    let payload = {
      data: saleData,
      onSuccess: (data) => {
        Swal.fire({
          icon: 'success',
          title: t('common.saved'),
          text: t('bonLivraison.savedSuccess'),
        });
        setReceiptData(data);
        setModal(true);
        dispatch(saleActions.clearCart());
        setPaymentModal(false);
        setSelectedClient(null);
        setSelectedCommercial(null);
        setSelectedEntrepot(null);
        setSelectedTransporteur(null);
        setSelectedChantier(null);
        formik.resetForm();
      },
      onError: (error) => {
        Swal.fire({
          icon: 'error',
          title: t('sale.error'),
          text: error.message || t('sale.errorMessage')
        });
      }
    };

    dispatch(deliveryActions.add(payload));
  };


  const handleCreateClient = () => {
    setShowClientModal(true);
  };

  const handleSelectedClient = (selectedOption) => {
    setSelectedClient(selectedOption);
    setSelectedChantier(null); // Reset chantier selection when client changes
    dispatch(reglementActions.echeanceClient({ ...filters, clientId: selectedOption.value }));
    dispatch(reglementActions.cautionClient({ ...filters, clientId: selectedOption.value }));
    setFilters(f => ({ ...f, clientId: selectedOption.value }));
    setShowClientModal(false);
  }

  const handleSelectedChantier = (selectedOption) => {
    setSelectedChantier(selectedOption);
  };

  // Create chantier options from selected client's chantiers
  const chantierOptions = selectedClient?.chantiers?.map(chantier => ({
    value: chantier.id,
    label: `${chantier.code} - ${chantier.nom}`,
    ...chantier
  })) || [];

  const handleSelectedCommercial = (selectedOption) => {
    setSelectedCommercial(selectedOption);
  };

  const handleClientChange = (e) => {
    const { name, value } = e.target;
    setClient((prev) => ({
      ...prev,
      [name]: name === 'active' ? value === 'true' : value, // Convert "true"/"false" to boolean for the active field
    }));
  };

  const getTotalMontant = (items) => {
    return items.reduce((total, item) => total + item.montantRegle, 0);
  };

  const getTotalQuantitiesFromReceipt = (receiptData) => {
    if (!receiptData || !receiptData.lignes) return 0;
    return receiptData.lignes.reduce((total, item) => total + parseFloat(item.quantiteLivree || 0), 0);
  };

  const handleDownloadTicket = async () => {
    try {
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: [80, 300],
      });

      const pageWidth = 80;
      const margin = 4;
      let y = 6;

      // === HEADER ===
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(14);
      doc.text(businessName || 'MATJARPOS', pageWidth / 2, y, { align: 'center' });
      y += 5;

      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');
      if (address) {
        const lines = doc.splitTextToSize(address, pageWidth - margin * 2);
        lines.forEach((line, i) => doc.text(line, pageWidth / 2, y + i * 3, { align: 'center' }));
        y += lines.length * 3;
      }
      if (telephone || email) {
        if (telephone) doc.text(` ${telephone}`, pageWidth / 2, y + 4, { align: 'center' });
        if (email) doc.text(`${email}`, pageWidth / 2, y + 8, { align: 'center' });
        y += email ? 10 : 6;
      }

      // Fine separator
      doc.setLineWidth(0.3);
      doc.line(margin, y, pageWidth - margin, y);
      y += 5;

      // === RECEIPT INFO ===
      doc.setFontSize(9);
      doc.setFont('helvetica', 'bold');
      doc.text('REÇU DE VENTE', pageWidth / 2, y, { align: 'center' });
      y += 6;

      doc.setFontSize(7);
      doc.setFont('helvetica', 'normal');
      doc.text(`N°: ${receiptData?.numero || '---'}`, margin, y);
      doc.text(`Date: ${receiptData?.dateOperation || '---'}`, pageWidth - margin, y, { align: 'right' });
      y += 4;
      doc.text(`Caissier: ${receiptData?.createdBy || '---'}`, margin, y);
      y += 4;

      // === CLIENT ===
      if (receiptData?.clientNom) {
        const clientText = doc.splitTextToSize(receiptData.clientNom, pageWidth - 30);
        doc.text('Client:', margin, y);
        clientText.forEach((t, i) => doc.text(t, margin + 15, y + i * 3));
        y += clientText.length * 3 + 2;
      } else {
        doc.text('Client: Passager', margin, y);
        y += 4;
      }



      doc.setLineWidth(0.2);
      doc.line(margin, y, pageWidth - margin, y);
      y += 4;

      // === ITEMS TABLE ===
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(7);
      doc.text('Article', margin, y);
      doc.text('Qté', pageWidth - 33, y);
      doc.text('PU', pageWidth - 22, y);
      doc.text('Total', pageWidth - margin, y, { align: 'right' });
      y += 3;
      doc.setLineWidth(0.1);
      doc.line(margin, y, pageWidth - margin, y);
      y += 3;

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7);
      let subtotal = 0;

      receiptData?.lignes?.forEach((item, i) => {
        if (y > 250) {
          doc.addPage([80, 300]);
          y = 6;
        }

        const name = item.articleNom.length > 24 ? item.articleNom.slice(0, 24) + '…' : item.articleNom;
        doc.text(name, margin, y);

        const unit = unites.find(u => u.code === item.unite)?.libelle || '';
        doc.text(`${item.quantiteLivree} ${unit}`, pageWidth - 35, y);
        doc.text(formatPrice(item.prixUnitaireTTC, false), pageWidth - 23, y);
        doc.text(formatPrice(item.montantTTC, false), pageWidth - margin, y, { align: 'right' });
        subtotal += parseFloat(item.montantTTC);
        y += 6;

        // if (i < receiptData.lignes.length - 1) {
        //   doc.setLineWidth(0.05);
        //   doc.line(margin + 5, y, pageWidth - margin - 5, y);
        //   y += 4;
        // }
      });

      y += 2;
      doc.setLineWidth(0.3);
      doc.line(margin, y, pageWidth - margin, y);
      y += 4;

      // === TOTALS ==

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
      doc.text('TOTAL:', margin, y);
      doc.text(formatPrice(receiptData?.montantTotalTTC || subtotal, false), pageWidth - margin, y, { align: 'right' });
      y += 6;

      doc.setLineWidth(0.3);
      doc.line(margin, y, pageWidth - margin, y);
      y += 5;

      // === PAYMENT ===
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      const paymentText =
        formik.values.modeReglement === 'ESPECES' ? 'Espèces' :
          formik.values.modeReglement === 'CARTE_BANCAIRE' ? 'Carte Bancaire' :
            formik.values.modeReglement || '---';
      doc.text(`Paiement: ${paymentText}`, margin, y);
      y += 6;

      if (formik.values.montantPaye) {
        doc.text('Montant reçu:', margin, y);
        doc.text(formatPrice(formik.values.montantPaye, false), pageWidth - margin, y, { align: 'right' });
        y += 4;

        if (formik.values.modeReglement === 'ESPECES' &&
          formik.values.montantPaye > receiptData?.montantTotalTTC) {
          doc.text('Monnaie:', margin, y);
          doc.text(formatPrice(formik.values.montantPaye - receiptData.montantTotalTTC, false), pageWidth - margin, y, { align: 'right' });
          y += 4;
        }
      }

      // if (receiptData?.clientSolde !== undefined && receiptData?.clientSolde !== null) {
      //   doc.setFont('helvetica', 'bold');
      //   doc.setFontSize(12);
      //   doc.text("Solde actuel est:", margin, y);

      //   doc.setFont('helvetica', 'normal');
      //   doc.text(formatSigned(receiptData.clientTotalDebit, receiptData.clientTotalCredit), pageWidth - margin, y, { align: "right" });

      //   y += 6;

      //   doc.setLineWidth(0.2);
      //   doc.line(margin, y, pageWidth - margin, y);
      //   y += 5;
      // }

      y += 6;
      doc.setLineWidth(0.2);
      doc.line(margin, y, pageWidth - margin, y);
      y += 6;

      // === FOOTER ===
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(9);
      doc.text('MERCI DE VOTRE VISITE!', pageWidth / 2, y, { align: 'center' });
      y += 4;

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7);
      doc.text('Gardez votre reçu pour tout échange.', pageWidth / 2, y, { align: 'center' });
      y += 3;
      doc.text('Échange possible sous 7 jours.', pageWidth / 2, y, { align: 'center' });
      y += 5;

      doc.setFontSize(6);
      doc.text('Powered by MatjarPOS', pageWidth / 2, y, { align: 'center' });

      // === EXPORT ===
      const pdfBlob = doc.output('blob');
      window.open(URL.createObjectURL(pdfBlob));

    } catch (err) {
      console.error('Error generating receipt:', err);
      Swal.fire({
        icon: 'error',
        title: 'Erreur',
        text: 'Erreur lors de la génération du reçu client',
      });
    }
  };

  // Add formik hook
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      handleCreateSale(values);
      resetForm();
    }
  });

  const entrepotOptions = entrepots?.map(entrepot => ({
    value: entrepot.id,
    label: entrepot.code + ' - ' + entrepot.libelle,
  })) ?? [];

  console.log(receiptData)
  return (
    <Container fluid>
      <Card className="mb-3">
        <CardBody className="py-3">
          <Row className="align-items-center g-3">

            <Col md={3} className="mb-0">
              <FormGroup>
                <Label htmlFor="clientId" className="mb-0 me-2 text-nowrap fw-bold text-secondary">
                  <FaUser className="me-1" /> {t('commande.client')}:
                </Label>
                <div className="flex-grow-1">
                  <Select
                    id="clientId"
                    options={clientOptions}
                    value={clientOptions.find(option => option.value === selectedClient?.value) || null}
                    onChange={(selectedOption) => handleSelectedClient(selectedOption)}
                    placeholder={t('bonLivraison.selectClient')}
                    isSearchable
                    className="rounded-3 border border-2"
                    menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </div>
                {/* <Button
                  color="primary"
                  size="sm"
                  onClick={handleCreateClient}
                  className="ms-1 rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: 32, height: 32 }}
                  title={t('client.newClient')}
                >
                  <FaPlus />
                </Button> */}
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label htmlFor="chantierId" className="mb-0 me-2 text-nowrap fw-bold text-secondary">
                  <FaBuilding className="me-1" /> {t('chantier.title', 'Chantier')}:
                </Label>
                <div className="flex-grow-1">
                  <Select
                    id="chantierId"
                    options={chantierOptions}
                    value={chantierOptions.find(option => option.value === selectedChantier?.value) || null}
                    onChange={(selectedOption) => handleSelectedChantier(selectedOption)}
                    placeholder={t('chantier.select', 'Sélectionner...')}
                    isSearchable
                    isClearable
                    className="rounded-3 border border-2"
                    menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </div>
              </FormGroup>
            </Col>
            <Col md={2} className="mb-0">
              <FormGroup>
                <Label for="commercialSelect" className="mb-0 me-2 text-nowrap fw-bold text-secondary">
                  <FaUser className="me-1" /> {t('commande.commercial')}
                </Label>
                <div className="flex-grow-1">
                  <Select
                    id="commercialSelect"
                    options={commercialOptions}
                    className="rounded-3 border border-2"
                    placeholder={t('bonLivraison.selectClient')}
                    value={commercialOptions.find(option => option.value === selectedCommercial?.value) || null}
                    onChange={(selectedOption) => handleSelectedCommercial(selectedOption)}
                    isSearchable
                    menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </div>
              </FormGroup>
            </Col>
            <Col md={2} className="mb-0">
              <FormGroup>
                <Label htmlFor="entrepotId" className="mb-0 me-2 text-nowrap fw-bold text-secondary"><FaStore className="me-1" />{t('bonLivraison.entrepot')}:</Label>
                <Select
                  id="entrepotId"
                  options={entrepotOptions}
                  value={entrepotOptions.find(option => option.value === selectedEntrepot?.value) || null}
                  onChange={(selectedOption) => setSelectedEntrepot(selectedOption)}
                  placeholder={t('bonLivraison.selectEntrepot')}
                  isSearchable
                  className="rounded-3 border border-2"
                />
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label htmlFor="dateOperation" className="fw-bold text-secondary"><FaCalendarAlt className="me-1" />{t('bonLivraison.dateOperation')}:</Label>
                <Input
                  type="date"
                  id="dateOperation"
                  name="dateOperation"
                  value={formik.values.dateOperation}
                  onChange={formik.handleChange}
                  className="form-control rounded-3 border border-2"
                />
              </FormGroup>
            </Col>
          </Row>

          {selectedClient && (
            <Row className="mt-2 g-2">
              <Col>
                <Row className="g-2 align-items-stretch">
                  <Col xs={6} md={2}>
                    <Card className="shadow-sm h-100 bg-light border-0 rounded-2">
                      <CardBody className="d-flex flex-column justify-content-center align-items-center py-2">
                        <FaBalanceScale className="mb-1 text-success" size={20} />
                        <span className="text-muted text-uppercase" style={{ fontSize: '0.7rem' }}>{t('client.balance')}</span>
                        {selectedClient.totalCredit > selectedClient.totalDebit ? (
                          <span className="fw-bold text-success" style={{ fontSize: '0.9rem' }}>+{formatPrice(Math.abs(selectedClient.solde))}</span>
                        ) : selectedClient.totalCredit < selectedClient.totalDebit ? (
                          <span className="fw-bold text-danger" style={{ fontSize: '0.9rem' }}>-{formatPrice(Math.abs(selectedClient.solde))}</span>
                        ) : (
                          <span className="fw-bold text-muted" style={{ fontSize: '0.9rem' }}>{formatPrice(0)}</span>
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xs={6} md={2}>
                    <Card className="shadow-sm h-100 bg-light border-0 rounded-2">
                      <CardBody className="d-flex flex-column justify-content-center align-items-center py-2">
                        <FaArrowDown className="mb-1 text-danger" size={20} />
                        <span className="text-muted text-uppercase" style={{ fontSize: '0.7rem' }}>{t('client.totalDebit')}</span>
                        <span className="fw-bold" style={{ fontSize: '0.9rem' }}>{formatPrice(selectedClient.totalDebit)}</span>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xs={6} md={2}>
                    <Card className="shadow-sm h-100 bg-light border-0 rounded-2">
                      <CardBody className="d-flex flex-column justify-content-center align-items-center py-2">
                        <FaArrowUp className="mb-1 text-primary" size={20} />
                        <span className="text-muted text-uppercase" style={{ fontSize: '0.7rem' }}>{t('client.totalCredit')}</span>
                        <span className="fw-bold" style={{ fontSize: '0.9rem' }}>{formatPrice(selectedClient.totalCredit)}</span>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xs={6} md={3}>
                    <Card className="shadow-sm h-100 bg-warning bg-opacity-10 border-0 rounded-2">
                      <CardBody className="d-flex flex-column justify-content-center align-items-center py-2">
                        <div className="d-flex align-items-center mb-1">
                          <FaCalendarAlt className="me-1 text-warning" size={16} />
                          <span className="text-muted text-uppercase" style={{ fontSize: '0.7rem' }}>{t('client.echeances')}</span>
                        </div>
                        <span className="fw-bold text-warning" style={{ fontSize: '0.9rem' }}>{echeances?.length || 0}</span>
                        <Button color="link" size="sm" className="p-0 fw-bold text-warning" style={{ fontSize: '0.7rem' }} onClick={() => setShowEcheanceModal(true)}>
                          {t('client.viewDetails')}
                        </Button>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xs={6} md={3}>
                    <Card className="shadow-sm h-100 bg-info bg-opacity-10 border-0 rounded-2">
                      <CardBody className="d-flex flex-column justify-content-center align-items-center py-2">
                        <div className="d-flex align-items-center mb-1">
                          <FaShieldAlt className="me-1 text-info" size={16} />
                          <span className="text-muted text-uppercase" style={{ fontSize: '0.7rem' }}>{t('client.cautions')}</span>
                        </div>
                        <span className="fw-bold text-info" style={{ fontSize: '0.9rem' }}>{cautions?.length || 0}</span>
                        <Button color="link" size="sm" className="p-0 fw-bold text-info" style={{ fontSize: '0.7rem' }} onClick={() => setShowCautionModal(true)}>
                          {t('client.viewDetails')}
                        </Button>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </CardBody>
      </Card>



      <Row className="mt-2 g-3">
        {/* Cart Block */}
        <Col md={7} className="ps-4 border-start">
          <Card className="shadow-sm h-100 rounded-4 border-0">
            <div className="card-header bg-light d-flex align-items-center justify-content-between py-3 rounded-top-4 border-bottom">
              <div className="d-flex align-items-center gap-2">
                <div className="position-relative">
                  <FaShoppingCart size={22} className="text-primary" />
                  {cart.length > 0 && (
                    <Badge
                      color="danger"
                      pill
                      className="position-absolute d-flex align-items-center justify-content-center"
                      style={{
                        top: '-8px',
                        right: '-12px',
                        fontSize: '0.75rem',
                        width: '18px',
                        height: '18px',
                        padding: 0
                      }}
                    >
                      {cart.length}
                    </Badge>
                  )}
                </div>
                <h5 className="mb-0 fw-bold text-uppercase text-primary">{t('cart.title')}</h5>
              </div>
              {cart.length > 0 && (
                <Button
                  color="danger"
                  size="sm"
                  onClick={handleClearCart}
                  className="rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: 32, height: 32 }}
                  title={t('cart.clear')}
                >
                  <FaTrash size={14} />
                </Button>
              )}
            </div>
            <CardBody className="p-0 rounded-bottom-4">
              {cart.length === 0 ? (
                <div className="text-center py-5">
                  <img
                    src={emptyCart}
                    alt="Empty Cart"
                    style={{
                      width: '120px',
                      opacity: '0.4',
                      marginBottom: '1rem'
                    }}
                  />
                  <p className="text-muted fs-6">{t('cart.empty')}</p>
                </div>
              ) : (
                <>
                  <div className="cart-container px-2 pt-2" style={{ height: '320px', overflowY: 'auto', fontSize: '0.95rem' }}>
                    <Table hover responsive className="mb-0 cart-table">
                      <thead className="bg-light position-sticky top-0" style={{ zIndex: 1 }}>
                        <tr>
                          <th className="text-uppercase text-secondary" style={{ width: 130 }}>{t('devis.article')}</th>
                          <th className="text-uppercase text-secondary" style={{ width: 100 }}>{t('devis.quantite')}</th>
                          <th className="text-uppercase text-secondary" style={{ width: 100 }}>{t('devis.unite')}</th>
                          <th className="text-uppercase text-secondary" style={{ width: 150 }}>{t('devis.prixUnitaireTTC')}</th>
                          <th className="text-uppercase text-secondary" style={{ width: 150 }}>{t('devis.prixVente')}</th>

                          <th className="text-uppercase text-secondary" style={{ width: 150 }}>{t('devis.montantTTC')}</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentCartItems.map((item, index) => (
                          <tr key={item.id} className="align-middle">
                            <td style={{ maxWidth: '200px' }}>
                              <Input
                                type="text"
                                name="articleNom"
                                value={item.articleNom}
                                disabled
                                className="bg-light border-0 fw-bold text-uppercase"
                              />
                            </td>
                            <td>
                              <Input
                                type="number"
                                onFocus={(e) => {
                                  e.target.select();
                                  e.target.addEventListener('wheel', preventScroll, { passive: false });
                                }}
                                onBlur={(e) => {
                                  e.target.removeEventListener('wheel', preventScroll);
                                }}

                                name="quantite"
                                value={item.quantite}
                                onChange={(event) => handleInputChange(index, event)}
                                className="border-0 text-center fw-bold no-spinner"

                              />
                            </td>
                            <td>
                              <Input
                                type="text"
                                name="unite"
                                value={unites.find(u => u.code === item.unite)?.libelle}
                                onChange={(event) => handleInputChange(index, event)}
                                disabled
                                className="bg-light border-0 text-uppercase text-center fw-bold"
                              />
                            </td>
                            <td style={{ width: '100px' }}>
                              {
                                item.prixVariable ?
                                  <Input
                                    type="number"
                                    onFocus={(e) => {
                                      e.target.select();
                                      e.target.addEventListener('wheel', preventScroll, { passive: false });
                                    }}
                                    onBlur={(e) => {
                                      e.target.removeEventListener('wheel', preventScroll);
                                    }}
                                    name="prixUnitaireTTC"
                                    value={item.prixUnitaireTTC}
                                    onChange={(event) => handleInputChange(index, event)}
                                    className="border-0 text-end fw-bold no-spinner"
                                  /> :
                                  <Input
                                    type="select"
                                    name="prixUnitaireTTC"
                                    value={item.prixUnitaireTTC}
                                    onChange={(event) => handleInputChange(index, event)}
                                    className="border-0 text-end fw-bold"
                                  >
                                    {item.prices && item.prices.map((price, priceIndex) => (
                                      <option key={priceIndex} value={price}>
                                        {formatPrice(price, false)}
                                      </option>
                                    ))}
                                  </Input>

                              }

                            </td>
                            <td>
                              <Input
                                type="number"
                                name="prixUnitaireTTC"
                                onFocus={(e) => {
                                  e.target.select();
                                  e.target.addEventListener('wheel', preventScroll, { passive: false });
                                }}
                                onBlur={(e) => {
                                  e.target.removeEventListener('wheel', preventScroll);
                                }}
                                value={item.prixUnitaireTTC}
                                onChange={(event) => handleInputChange(index, event)}
                                className="border-0 text-center fw-bold no-spinner"

                              />
                            </td>
                            <td>
                              <Input
                                type="text"
                                name="montantTTC"
                                value={formatPrice(item.montantTTC, false)}
                                disabled
                                className="bg-light border-0 text-end fw-bold"
                              />
                            </td>
                            <td style={{ width: '40px' }}>
                              <Button
                                color="link"
                                className="p-0 text-danger"
                                onClick={() => handleRemoveFromCart(item.articleId)}
                                size="sm"
                                title={t('cart.remove')}
                              >
                                <FaTrash size={14} />
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <div className="border-top p-3 bg-light rounded-bottom-4">
                    {/* <div className="d-flex justify-content-between align-items-center mb-2">
                      <div className="fs-6 fw-bold text-muted text-uppercase ps-2">
                        {t('cart.totalHT')}
                      </div>
                      <div className="fs-5 fw-bold text-primary pe-2">
                        {formatPrice(montantTotalHT)}
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div className="fs-6 fw-bold text-muted text-uppercase ps-2">
                        {t('cart.totalTVA')}
                      </div>
                      <div className="fs-5 fw-bold text-primary pe-2">
                        {formatPrice(montantTotalTaxe)}
                      </div>
                    </div> */}
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div className="fs-6 fw-bold text-muted text-uppercase ps-2">
                        {t('cart.totalTTC')}
                      </div>
                      <div className="fs-5 fw-bold text-primary pe-2">
                        {formatPrice(montantTotalTTC)}
                      </div>
                    </div>
                    <Button
                      color="success"
                      className="w-100 mt-3 py-2 rounded-3 fs-5 fw-bold"
                      size="xl"
                      onClick={() => {
                        if (!selectedEntrepot) {
                          Swal.fire({
                            icon: 'warning',
                            title: t('sale.errorTitle'),
                            text: t('sale.entrepotRequired')
                          });
                          return;
                        }

                        if (!cart.length) {
                          Swal.fire({
                            icon: 'warning',
                            title: t('cart.empty'),
                            text: t('cart.emptyMessage')
                          });
                          return;
                        }

                        togglePaymentModal(true);
                      }}
                    >
                      <FaShoppingCart className="me-2" />
                      {t('cart.checkout')}
                    </Button>
                  </div>
                </>
              )}
            </CardBody>
          </Card>
        </Col>
        {/* Product List Block */}
        <Col md={5} className="pe-4">
          <Card className="shadow-sm h-100 rounded-4 border-0">
            <CardBody className="rounded-bottom-4">
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">{t('common.loading')}</span>
                  </div>
                  <div className="mt-2 text-muted">
                    {t('common.loadingData')}
                  </div>
                </div>
              ) : (
                <>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="position-relative flex-grow-1 me-3">
                      <Input
                        innerRef={searchInputRef}
                        type="text"
                        placeholder={t('product.searchFocusHint')}
                        value={searchTerm}
                        onKeyDown={handleSearchKeyDown}
                        onChange={handleSearchChange}
                        className={`ps-4 pe-5 rounded-3 border border-2 ${isSearching ? 'searching' : ''}`}
                        title={t('product.searchShortcut')}
                        style={{ textTransform: 'uppercase', fontWeight: 500, letterSpacing: '1px' }}
                      />
                      <FaSearch
                        style={{
                          position: 'absolute',
                          left: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          color: '#adb5bd'
                        }}
                        size={16}
                      />
                      <FaBarcode
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          color: '#adb5bd'
                        }}
                        size={22}
                        title={t('product.scanHint')}
                      />
                    </div>
                  </div>
                  <DisplayToggle />
                  {displayMode === 'table' ? <TableView /> : <CardView />}
                </>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>


      {/* Receipt Modal */}
      <Modal isOpen={modal} toggle={() => setModal(false)}>
        <ModalHeader toggle={() => setModal(false)}>
          {t('receipt.title')}
        </ModalHeader>
        <ModalBody>
          <div
            id="receipt-content"
            className="p-4 bg-white shadow-sm rounded"
            style={{ width: '100%' }}
          >
            {/* Header */}
            <div className="text-center mb-4">
              <h5 className="mb-2">
                <FaStore className="me-2 text-secondary" />
                {businessName}
              </h5>
              <small className="d-block mb-2">
                <FaMapMarkerAlt className="me-1 text-secondary" />
                {address}
              </small>
              <div className="d-flex justify-content-center align-items-center gap-3">
                {telephone && (
                  <small>
                    <FaWhatsapp className="me-1 text-secondary" />
                    {telephone}
                  </small>
                )}
                <small>
                  <FaEnvelope className="me-1 text-secondary" />
                  {email}
                </small>
              </div>
            </div>

            <hr />

            {/* Receipt Details */}
            <div className="mb-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <FaReceipt className="me-2 text-secondary" />
                  <span className="fw-bold">{t('sale.receipt.receiptNo')} </span>
                  {receiptData?.numero}
                </div>
                <div>
                  <FaCalendarAlt className="me-2 text-secondary" />
                  <span className="fw-bold">{t('sale.receipt.date')} </span>
                  {receiptData?.dateOperation}
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <FaUser className="me-2 text-secondary" />
                  <span className="fw-bold">{t('sale.receipt.seller')} </span>
                  {receiptData?.createdBy}
                </div>
                <div>
                  <FaUser className="me-2 text-secondary" />
                  <span className="fw-bold">{t('sale.receipt.client')} </span>
                  {receiptData?.clientNom ? receiptData?.clientNom : 'Passager'}
                </div>
              </div>
            </div>
            <hr />

            {/* Products Table */}
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>{t('product.description')}</th>
                  <th className="text-end">{t('sale.receipt.price')}</th>
                  <th className="text-end">{t('sale.receipt.quantity')}</th>
                  <th className="text-end">{t('sale.receipt.unite')}</th>
                  <th className="text-end">{t('sale.receipt.total')}</th>
                </tr>
              </thead>
              <tbody>
                {receiptData && receiptData.lignes.map((item, index) => (
                  <tr key={index}>
                    <td>{item.articleNom}</td>
                    <td className="text-end">{formatPrice(item.prixUnitaireTTC, false)}</td>
                    <td className="text-end">{item.quantiteLivree}</td>
                    <td className="text-end">{unites.find(u => u.code === item.unite).libelle}</td>
                    <td className="text-end">{formatPrice(item.montantTTC, false)}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <hr />


            {/* Totals with paid, change, solde */}
            <div className="text-end mb-4">
              <div className="mb-2">
                <span className="fw-bold me-3">{t('sale.receipt.totalQuantity')}</span>
                <span className="fw-bold text-success">{getTotalQuantitiesFromReceipt(receiptData)}</span>
              </div>
              <div className="mb-2">
                <span className="fw-bold me-3">{t('sale.receipt.total')}</span>
                {formatPrice(receiptData?.montantTotalTTC)}
              </div>

            </div>

            {/* Footer */}
            <div className="text-center mt-4">
              <p className="mb-1">{t('sale.receipt.thankYou')}</p>
              <small className="text-muted">{t('sale.receipt.footer')}</small>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={generatePDF}>
            <FaPrint className="me-1" />
            {t('receipt.printBill')}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Payment Modal */}
      <Modal isOpen={paymentModal} toggle={togglePaymentModal} size="xl">
        <ModalHeader toggle={togglePaymentModal}>
          {t('sale.confirmSale')}
        </ModalHeader>
        <ModalBody>
          <Card className="border-0 shadow-sm bg-light bg-gradient mb-3">
            <CardBody>
              <Row className="mb-3">
                <Col md="6" className="d-flex flex-column justify-content-center">
                  <div className="mb-2 text-muted fw-bold text-uppercase small">
                    <FaMoneyBillWave className="me-2 text-success" /> {t('payment.totalDue')}
                  </div>
                  <div className="fs-3 fw-bold text-success">
                    {formatPrice(montantTotalTTC)}
                  </div>
                </Col>
                <Col md="6" className="d-flex flex-column justify-content-center">
                  <div className="mb-2 text-muted fw-bold text-uppercase small">
                    <FaCreditCard className="me-2 text-primary" /> {t('payment.method')}
                  </div>
                  <div className="d-flex gap-3">
                    <Button
                      color={formik.values.modeReglement === 'ESPECES' ? 'primary' : 'secondary'}
                      onClick={() => formik.setFieldValue('modeReglement', 'ESPECES')}
                      active={formik.values.modeReglement === 'ESPECES'}
                      className="d-flex align-items-center px-4 py-2"
                    >
                      <FaMoneyBillWave className="me-2" /> {t('facture.modeReglement.espece')}
                    </Button>
                    <Button
                      color={formik.values.modeReglement === 'CARTE_BANCAIRE' ? 'primary' : 'secondary'}
                      onClick={() => formik.setFieldValue('modeReglement', 'CARTE_BANCAIRE')}
                      active={formik.values.modeReglement === 'CARTE_BANCAIRE'}
                      className="d-flex align-items-center px-4 py-2"
                    >
                      <FaCreditCard className="me-2" /> {t('facture.modeReglement.card')}
                    </Button>
                  </div>
                  {formik.touched.modeReglement && formik.errors.modeReglement && (
                    <div className="invalid-feedback d-block mt-2">{formik.errors.modeReglement}</div>
                  )}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md="6">
                  <FormGroup>
                    <Label className="fw-bold text-muted">{t('payment.amountPaid')}</Label>
                    <Input
                      type="number"
                      name="montantPaye"
                      value={formik.values.montantPaye}
                      onChange={formik.handleChange}
                      onFocus={(e) => e.target.select()}
                      min={0}
                      step="0.5"
                      className="py-2 fs-5"
                    />
                  </FormGroup>
                </Col>
                {formik.values.modeReglement === 'ESPECES' && (
                  <Col md="6">
                    <FormGroup>
                      <Label className="fw-bold text-muted">{t('payment.change')}</Label>
                      <Input
                        type="number"
                        value={((formik.values.montantPaye || montantTotalTTC) - montantTotalTTC).toFixed(2)}
                        disabled
                        className="bg-light text-success py-2 fs-5"
                      />
                    </FormGroup>
                  </Col>
                )}
              </Row>
              <Row className="mb-3">
                <Col md="12">
                  <FormGroup>
                    <Label htmlFor="transporteurId" className="fw-bold text-muted">{t('bonLivraison.transporteur')}:</Label>
                    <Select
                      id="transporteurId"
                      options={transporteurOptions}
                      value={transporteurOptions.find(option => option.value === selectedTransporteur?.value)}
                      onChange={(selectedOption) => setSelectedTransporteur(selectedOption)}
                      placeholder={t('bonLivraison.selectTransporteur')}
                      isSearchable
                    />
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="primary" size="lg" className="px-4" onClick={() => handleCreateSale(formik.values)}>
            {t('payment.confirm')}
          </Button>
          <Button color="secondary" size="lg" className="px-4 ms-2" onClick={togglePaymentModal}>
            {t('payment.cancel')}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={clearCartModal} toggle={toggleClearCartModal} size="xl">
        <ModalHeader toggle={toggleClearCartModal}>
          {t('cart.clearConfirmTitle')}
        </ModalHeader>
        <ModalBody>
          {t('cart.clearConfirmMessage')}
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleClearCart}>
            {t('cart.confirm')}
          </Button>
          <Button color="secondary" onClick={toggleClearCartModal}>
            {t('cart.cancel')}
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={clientModal} toggle={toggleClientModal}>
        <ModalHeader toggle={toggleClientModal}>
          {t('facture.client.selectClient')}
        </ModalHeader>
        <ModalBody>
          {showClientForm ? (
            <ClientForm
              onClientAdded={handleClientAdded}
              onCancel={() => setShowClientForm(false)}
            />
          ) : (
            <ListGroup>
              {clients.map((client) => (
                <ListGroupItem
                  key={client.id}
                  action
                  onClick={() => handleSelectClient(client)}
                >
                  {client.type === 'particulier' ? `${client.firstName} ${client.lastName}` : client.businessName}
                </ListGroupItem>
              ))}
            </ListGroup>
          )}
        </ModalBody>
        <ModalFooter>
          {!showClientForm && (
            <Button color="primary" onClick={() => setShowClientForm(true)}>
              {t('facture.client.create')}
            </Button>
          )}
          <Button color="secondary" onClick={toggleClientModal}>
            {t('common.cancel')}
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={showClientModal} toggle={() => setShowClientModal(false)} size="xl">
        <ModalHeader toggle={() => setShowClientModal(false)}>
          {t('client.newClient')}
        </ModalHeader>
        <ModalBody>
          <Card className="border-0 shadow-sm">
            <CardBody className="p-2">
              <Row>
                <Col md={3}>
                  <FormGroup className="mb-4">
                    <Label for="typeClient" className="fw-bold">
                      <FaIdCard className="me-2 text-muted" />
                      Type de Client*
                    </Label>
                    <Input
                      type="select"
                      id="typeClient"
                      name="typeClient"
                      value={client.typeClient}
                      onChange={handleClientChange}
                      className="py-2"
                    >
                      <option value="PARTICULIER">Particulier</option>
                      <option value="ENTREPRISE">Entreprise</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              {client.typeClient === 'PARTICULIER' &&
                <Row>
                  <Col md={3}>
                    <FormGroup className="mb-4">
                      <Label for="nom" className="fw-bold">
                        <FaUser cclassName="me-2 text-muted" />
                        Nom*
                      </Label>
                      <Input
                        type="text"
                        id="nom"
                        name="nom"
                        value={client.nom}
                        onChange={handleClientChange}
                        invalid={!!clientErrors.nom}
                        placeholder="El Fassi"
                        className="py-2"
                      />
                      {clientErrors.nom && <div className="text-danger small mt-1">{clientErrors.nom}</div>}
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup className="mb-4">
                      <Label for="prenom" className="fw-bold">
                        <FaUser className="me-2 text-muted" />
                        Prénom*
                      </Label>
                      <Input
                        type="text"
                        id="prenom"
                        name="prenom"
                        value={client.prenom}
                        onChange={handleClientChange}
                        invalid={!!clientErrors.prenom}
                        placeholder="Karim"
                        className="py-2"
                      />
                      {clientErrors.prenom && <div className="text-danger small mt-1">{clientErrors.prenom}</div>}
                    </FormGroup>
                  </Col>

                  <Col md={3}>
                    <FormGroup className="mb-4">
                      <Label for="cin" className="fw-bold">
                        <FaIdCard className="me-2 text-muted" />
                        CIN
                      </Label>
                      <Input
                        type="text"
                        id="cin"
                        name="cin"
                        value={client.cin}
                        onChange={handleClientChange}
                        placeholder="AB123456"
                        className="py-2"
                      />
                    </FormGroup>
                  </Col>

                </Row>}
              {client.typeClient === 'ENTREPRISE' &&
                <Row>
                  <Col md={3}>
                    <FormGroup className="mb-4">
                      <Label for="entreprise" className="fw-bold">
                        <FaBuilding className="me-2 text-muted" />
                        Nom de l'entreprise
                      </Label>
                      <Input
                        type="text"
                        id="entreprise"
                        name="entreprise"
                        value={client.entreprise}
                        onChange={handleClientChange}
                        placeholder="Nom de l'entreprise"
                        className="py-2"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup className="mb-4">
                      <Label for="ice" className="fw-bold">
                        <FaIdCard className="me-2 text-muted" />
                        ICE
                      </Label>
                      <Input
                        type="text"
                        id="ice"
                        name="ice"
                        value={client.ice}
                        onChange={handleClientChange}
                        placeholder="Numéro ICE"
                        className="py-2"
                      />
                    </FormGroup>
                  </Col>
                </Row>}
              <Row>
                <Col md={3}>
                  <FormGroup className="mb-4">
                    <Label for="telephone" className="fw-bold">
                      <FaPhone className="me-2 text-muted" />
                      Téléphone (1) *
                    </Label>
                    <Input
                      type="tel"
                      id="telephone1"
                      name="telephone1"
                      value={client.telephone1}
                      onChange={handleClientChange}
                      invalid={!!clientErrors.telephone1}
                      placeholder="06 12 34 56 78"
                      className="py-2"
                    />
                    {clientErrors.telephone1 && <div className="text-danger small mt-1">{clientErrors.telephone1}</div>}
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup className="mb-4">
                    <Label for="telephone2" className="fw-bold">
                      <FaPhone className="me-2 text-muted" />
                      Téléphone (2) *
                    </Label>
                    <Input
                      type="tel"
                      id="telephone2"
                      name="telephone2"
                      value={client.telephone2}
                      onChange={handleClientChange}
                      invalid={!!clientErrors.telephone2}
                      placeholder="06 12 34 56 78"
                      className="py-2"
                    />
                    {clientErrors.telephone2 && <div className="text-danger small mt-1">{clientErrors.telephone2}</div>}
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup className="mb-4">
                    <Label for="email" className="fw-bold">
                      <FaEnvelope className="me-2 text-muted" />
                      Email
                    </Label>
                    <Input
                      type="email"
                      id="email"
                      name="email"
                      value={client.email}
                      onChange={handleClientChange}
                      placeholder="k.elfassi@example.com"
                      className="py-2"
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup className="mb-4">
                    <Label for="ville" className="fw-bold">
                      <FaMapMarkerAlt className="me-2 text-muted" />
                      Ville
                    </Label>
                    <Input
                      type="select"
                      id="ville"
                      name="ville"
                      value={client.ville}
                      onChange={handleClientChange}
                      className="py-2"
                    >
                      {villesMaroc.map(ville => (
                        <option key={ville} value={ville}>{ville}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>

              </Row>
              <Row>
                <Col md={3}>
                  <FormGroup className="mb-4">
                    <Label for="adresse" className="fw-bold">
                      <FaMapMarkerAlt className="me-2 text-muted" />
                      Adresse*
                    </Label>
                    <Input
                      type="textarea"
                      rows="2"
                      id="adresse"
                      name="adresse"
                      value={clientErrors.adresse}
                      onChange={handleClientChange}
                      invalid={!!clientErrors.adresse}
                      placeholder="12 Rue Moulay Rachid"
                      className="py-2"
                    />
                    {clientErrors.adresse && <div className="text-danger small mt-1">{clientErrors.adresse}</div>}
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup className="mb-4">
                    <Label for="codePostal" className="fw-bold">
                      <FaMapMarkerAlt className="me-2 text-muted" />
                      Code Postal
                    </Label>
                    <Input
                      type="text"
                      id="codePostal"
                      name="codePostal"
                      value={client.codePostal}
                      onChange={handleClientChange}
                      placeholder="20000"
                      className="py-2"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmitClient}>
            {t('common.save')}
          </Button>
          <Button color="secondary" onClick={() => setShowClientModal(false)}>
            {t('common.cancel')}
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={showEcheanceModal} toggle={() => setShowEcheanceModal(false)} size="lg">
        <ModalHeader toggle={() => setShowEcheanceModal(false)} className="bg-warning bg-opacity-10 border-0">
          <FaCalendarAlt className="me-2 text-warning" />
          <span className="fw-bold text-warning">{t('client.echeancesDetails')}</span>
        </ModalHeader>
        <ModalBody>
          {echeances && echeances.length > 0 ? (
            <div>
              <div className="mb-3 d-flex justify-content-between align-items-center">
                <span className="fw-bold text-warning fs-5">
                  <FaCalendarAlt className="me-2" /> {t('client.echeances')}: {echeances.length}
                </span>
                <span className="fw-bold text-muted">{t('echeance.total')}: <span className="text-warning">{formatPrice(getTotalMontant(echeances))}</span></span>
              </div>
              <Table bordered hover responsive className="table-sm">
                <thead className="bg-warning bg-opacity-10">
                  <tr>
                    <th>{t('echeance.reference')}</th>
                    <th>{t('echeance.dateReglement')}</th>
                    <th>{t('echeance.numeroCheque')}</th>
                    <th>{t('echeance.banque')}</th>
                    <th>{t('echeance.montantCheque')}</th>
                    <th>{t('echeance.dateEcheance')}</th>
                  </tr>
                </thead>
                <tbody>
                  {echeances.map((echeance, idx) => (
                    <tr key={idx}>
                      <td>{echeance.reference}</td>
                      <td>{echeance.dateReglement}</td>
                      <td>{echeance.numeroCheque}</td>
                      <td>{echeance.banque}</td>
                      <td className="text-end fw-bold text-warning">{formatPrice(echeance.montantRegle)}</td>
                      <td>{echeance.dateEcheance}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className="text-muted text-center py-4">{t('client.noEcheances')}</div>
          )}
        </ModalBody>
      </Modal>

      <Modal isOpen={showCautionModal} toggle={() => setShowCautionModal(false)} size="lg">
        <ModalHeader toggle={() => setShowCautionModal(false)} className="bg-info bg-opacity-10 border-0">
          <FaShieldAlt className="me-2 text-info" />
          <span className="fw-bold text-info">{t('client.cautionsDetails')}</span>
        </ModalHeader>
        <ModalBody>
          {cautions && cautions.length > 0 ? (
            <div>
              <div className="mb-3 d-flex justify-content-between align-items-center">
                <span className="fw-bold text-info fs-5">
                  <FaShieldAlt className="me-2" /> {t('client.cautions')}: {cautions.length}
                </span>
                <span className="fw-bold text-muted">{t('caution.total')}: <span className="text-info">{formatPrice(getTotalMontant(cautions))}</span></span>
              </div>
              <Table bordered hover responsive className="table-sm">
                <thead className="bg-info bg-opacity-10">
                  <tr>
                    <th>{t('caution.reference')}</th>
                    <th>{t('caution.dateReglement')}</th>
                    <th>{t('caution.numeroCheque')}</th>
                    <th>{t('caution.banque')}</th>
                    <th>{t('caution.montantCheque')}</th>
                    <th>{t('caution.dateEcheance')}</th>
                  </tr>
                </thead>
                <tbody>
                  {cautions.map((caution, idx) => (
                    <tr key={idx}>
                      <td>{caution.reference}</td>
                      <td>{caution.dateReglement}</td>
                      <td>{caution.numeroCheque}</td>
                      <td>{caution.banque}</td>
                      <td className="text-end fw-bold text-info">{formatPrice(caution.montantRegle)}</td>
                      <td>{caution.dateEcheance}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className="text-muted text-center py-4">{t('client.noCautions')}</div>
          )}
        </ModalBody>
      </Modal>
    </Container >
  );
};

export default SaleForm;
